import { Link } from "react-router-dom";
import { FaBullseye, FaHandshake, FaRoute, FaTrophy } from "react-icons/fa";
import Btn from "../Btn/index";
import "./styles.scss";

const Nosotros = () => {
	return (
		<section className="nosotros_cont">
			<div className="bienvenida_nosotros">
				<div>
					<span>NOSOTROS / DESDE 2004</span>
					<h1>Movemos carga con criterio operativo y compromiso nacional.</h1>
					<p>
						Una empresa de transporte terrestre que combina experiencia, cobertura y equipo humano para responder
						a operaciones de carga seca, masiva, semi-masiva y especializada.
					</p>
				</div>
			</div>

			<div className="nosotros_body">
				<div className="nuetra_empresa">
					<div className="section_icon">
						<FaTrophy />
					</div>
					<div>
						<span>Historia</span>
						<h2>Nuestra empresa</h2>
						<p>
							TRANSPORTES FORZAKARGO S.A.S. nace de una trayectoria empresarial constituida en el año 2004,
							con foco en <strong>transporte de carga a nivel nacional</strong>. Hoy atendemos operaciones de
							carga líquida, sólida, granel, masiva, semi-masiva, refrigerada, seca y transporte mixto.
						</p>
					</div>
				</div>

				<div className="mision_vision_grid">
					<div className="mision">
						<div className="section_icon">
							<FaBullseye />
						</div>
						<h4>Misión</h4>
						<p>
							Contribuir al desarrollo empresarial, económico y social del país mediante soluciones de
							transporte terrestre de carga con <strong>innovación, calidad, servicio y tecnología</strong>,
							desarrollando aliados estratégicos que respondan a la cadena de suministro de nuestros clientes.
						</p>
					</div>
					<div className="vision">
						<div className="section_icon">
							<FaRoute />
						</div>
						<h4>Visión</h4>
						<p>
							Posicionarnos como una empresa reconocida en carga masiva y semi-masiva, con
							<strong> altos estándares de calidad</strong>, equipo humano idóneo y una plataforma tecnológica
							orientada a operaciones más inteligentes.
						</p>
					</div>
				</div>

				<div className="mas_nosotros">
					<img alt="Equipo ForzaKargo" src="/images/nosotros2.png" loading="lazy" />
					<div>
						<FaHandshake />
						<span>Te estamos esperando.</span>
						<h3>Construyamos una ruta para tu operación.</h3>
						<Link to="/contacto">
							<Btn>Contáctanos</Btn>
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Nosotros;
